








































































































































import { Vue, Component, Prop } from 'vue-property-decorator';
import { inject } from 'inversify-props';
import { Route } from 'vue-router';
import { StockItemsTableCard } from '@/components/Patient/StockItemsTableCard.vue';
import PatientInfoCard from '@/components/Patient/PatientInfoCard.vue';
import StockAddDialogButton from '@/components/Patient/StockAddDialogButton.vue';
import StockRevisionDialogButton from '@/components/Patient/StockRevisionDialogButton.vue';
import { EventsTableCard } from '@/components/EventsTableCard.vue';
import { IEventService,IStockService, EventOrderBy, OrderByMode, StockOrderBy, IPatientService, IAuthService } from '@/interfaces/Services';
import { PatientModel } from '@/models/patient';
import { EventModel, EventType, EventStatus } from '@/models/event';
import { StockItemModel } from '@/models/stock';
import DependencyIdentifiers from '@/ioc/DependencyIdentifiers';
import { auth } from "@/store/modules";
import LambdaDownloader from '@/utils/lambda_downloader';

export enum PatientViewTab {
  Events = 'events',
  Stock = 'stock',
}

@Component({
  components: {
    PatientInfoCard,
    StockItemsTableCard,
    StockAddDialogButton,
    StockRevisionDialogButton,
    EventsTableCard,
  }
})
export class PatientView extends Vue {
  @inject(DependencyIdentifiers.EventService)
  private eventService!: IEventService;
  @inject(DependencyIdentifiers.AuthService)
  private authService!: IAuthService;
  @inject(DependencyIdentifiers.StockService)
  private stockService!: IStockService;
  @inject(DependencyIdentifiers.PatientService)
  private patientService!: IPatientService;

  public eventStatuses = [
    {
      value: 'approved',
      label: 'Elfogadva',
    },
    {
      value: 'pending',
      label: 'Függō',
    },
    {
      value: 'draft',
      label: 'Vázlat',
    },
    {
      value: 'rejected',
      label: 'Elutasítva',
    },
  ]

  private patient!: PatientModel;
  private componentKey = 0;
  private dialog = false;
  public picker = (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10);
  public selectedEventStatuses = [];
  private isLoading = true;
  private isNotFound = false;
  private recentVisitEvent: EventModel | null = null;
  private recentStockItem: StockItemModel |null = null;
  private pendingEventCount: number = 0;
  private availableStockUnit: number = 0;
  private tab: PatientViewTab = PatientViewTab.Events;

  async beforeMount() {
    this.isLoading = true;
    try {
      await this.fetchPatient();
      this.detectSelectedTab();

      await Promise.all([
        this.fetchRecentVisit(),
        this.fetchPendingEventCount(),
        this.fetchRecentStockItem(),
        this.fetchAvailableStockUnit(),
      ]);
    } catch (e) {
      this.isNotFound = true;
    } finally {
      this.isLoading = false;
    }
  }

  detectSelectedTab() {
    if (!this.$route.meta || !this.$route.meta.tab) { return; }
    const requestedTab = this.$route.meta.tab;
    switch(requestedTab) {
      case PatientViewTab.Events:
      case PatientViewTab.Stock:
        this.tab = `${requestedTab}` as PatientViewTab;
        this.applyUrl(this.tab);
        break;
      default:
        console.error(requestedTab);
    }
  }

  applyUrl(tab: PatientViewTab) {
    this.$router.push(`/dashboard/patients/${this.patient.$id}/${tab}`);
  }

  hasPatient() {
    return !!this.patient;
  }

  getAcceptedValue(accepted: boolean) {
    if (accepted === true) {
      return "Igen";
    }
    return "Nem";
  }

  async print() {
    if (this.isLoading) {
      return;
    }
    const from = new Date(parseInt(this.picker.substring(0, 4), 10), parseInt(this.picker.substring(5), 10) -1, 1).toISOString();
    const until = new Date(parseInt(this.picker.substring(0, 4), 10), parseInt(this.picker.substring(5), 10), 1).toISOString();
    const statuses = this.selectedEventStatuses.join(",");
    const token = await this.authService.fork();
    const download = new LambdaDownloader(
      {token, patientId: this.patient.$id, from, until, statuses},
      `patient-export`,
      `hemonaplo-patient-${this.patient.email}`,
      (isLoading) => this.isLoading = isLoading
    );
    await download.start();
    this.dialog = false;
  }

  private async fetchPatient() {
    const id = this.$route.params.id;
    if (!id) {
      console.error('id not defined');
      return;
    }
    this.patient = await this.patientService.getById(id);
    this.componentKey++;
  }

  private async fetchRecentVisit() {
    const orderBy = new Map([[EventOrderBy.$occuredAt, OrderByMode.Desc]]);
    const [result, {}] = await this.eventService.getMany(
      1,
      1,
      { patientId: this.patient!.$id, types: [EventType.Visit] },
      orderBy
    );

    if (result.length > 0) {
      this.recentVisitEvent = result[0];
    }
  }

  private async fetchPendingEventCount() {
    const [{}, total] = await this.eventService.getMany(
      1,
      1,
      { patientId: this.patient!.$id, statuses: [EventStatus.Pending] }
    );

    this.pendingEventCount = total;
  }

  private async fetchRecentStockItem() {
    const [result, total] = await this.stockService.getMany(
      1,
      1,
      { patientId: this.patient!.$id },
      new Map([[StockOrderBy.$updatedAt, OrderByMode.Desc]]),
    );
    if (result.length > 0) {
      this.recentStockItem = result[0];
    }
  }

  private async fetchAvailableStockUnit() {
    const [results] = await this.stockService.stats(1, -1, {patientId: this.patient!.$id});
    this.availableStockUnit = 0;
    results.forEach((item) => {
      this.availableStockUnit += item.counters.available * parseInt(item.$drug!.takeAmount as any, 10)
    });
  }

  private onStockAdded() {
    this.componentKey++;
  }

  private onStockRevisioned() {
    this.componentKey++;
  }

  get hasPrimaryCenter() {
    return auth.hasPrimaryCenter;
  }

  private onTabChanged() {
    this.componentKey++;
    this.applyUrl(this.tab);
  }
}

export default PatientView;
